export const getRandomFaqs = (faqs) =>{
    return faqs.sort(() => .5 - Math.random()).slice(0,8)
}